import {Base} from "@/api/Base"

export class MpfGetByIdUplRec extends Base {
    path = "mpf/getByIdUplRec"
}